const env = process.env.NODE_ENV || "development";

const domainEnvironment = {
  development: {
        domainAdminSide: "http://localhost:3001",
        domainUserSide: "http://localhost:3000",
        domainName:"",
  },
  production: {
      domainAdminSide: "https://admin.qhpccc.cgis.asia",
      domainUserSide: "https://qhpccc.cgis.asia",
      domainName:"qhpccc.cgis.asia",
  },
};

module.exports = domainEnvironment[env];
